import { authService, intentService, feedbackService, runConfigService } from '@xpanse/ui';

import axios from 'src/lib/axios';

// Initialize services with the configured axios instance
const AuthService = authService(axios);
const FeedbackService = feedbackService(axios);
const RunConfigService = runConfigService(axios);
const IntentService = intentService(axios);

// Export initialized services for use throughout the codebase
export { AuthService, IntentService, FeedbackService, RunConfigService };
